export default __webpack_public_path__ + "static/media/help_icon.6e13b03a.svg";